import React, { useEffect } from 'react';
import { useMe } from './useAuth';
import { useSelectedAccount } from './useAccounts';

const useIsStatusU = () => {
  const [isStatusU, setIsStatusU] = React.useState(false);
  const { data } = useMe();
  const {
    data: { selectedAccount },
  } = useSelectedAccount();
  useEffect(() => {
    if (selectedAccount?.status === 'U') {
      setIsStatusU(true);
    } else if (selectedAccount?.isJuristicPerson === false) {
      if (
        data?.principals[0]?.accounts.some((account: any) => {
          return account.status === 'U' && account.isJuristicPerson === false;
        })
      ) {
        setIsStatusU(true);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return isStatusU;
};

export default useIsStatusU;
